import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist"; //刷新保存状态
import axios from "axios";
import qs from "qs";
Vue.prototype.axios = axios;
Vue.use(Vuex);
var vuexLocal = new VuexPersistence({
  //配置vuex-persist
  storage: window.sessionStorage
});

export default new Vuex.Store({
  state: {
    nowScorllTop:0,
    isDone: false,
    keyword: "",
    querydata: {
      token: localStorage.getItem("token"),
      pages: 1,
      page_num: 10,
      itmsgrpcod: "",
      u_itmscod2: "",
      u_itmscod3: "",
      firmcode: "",
      price_order: "",
      sl_order: "",
      news_order: "",
      prcie1: "",
      prcie2: ""
    },
    u_partcode: "",
    Isupdata: false,
    scroll1: "", //分类的滚动值1
    scroll2: "" //分类的滚动值2
  },
  mutations: {
    SET_HOSPITAL(state, obj) {
      state.hospital = obj;
    },
    SAVE_BACK(state, str) {
      state.backurl = str;
    },
    SAVE_TEXT(state, str) {
      state.text = str;
    },
    SAVE_FROM(state, obj) {
      state.formData = obj;
    },
    querydata(state, querydata) {
      state.querydata = querydata;
    },
    pageAdd(state) {
      state.querydata.pages++;
    },
    Isupdata(state, Isupdata) {
      state.Isupdata = Isupdata;
    },
    EleScroll1(state, val) {
      //分类的滚动值1
      state.scroll1 = val;
    },
    EleScroll2(state, val) {
      //分类的滚动值1
      state.scroll2 = val;
    },
    keyword(state, val) {
      //分类的滚动值1
      state.keyword = val;
    },
    isDone(state, val) {
      //分类的滚动值1
      state.isDone = val;
    },
    nowScorllTop(state,val){
      state.nowScorllTop =val;
    },
    u_partcode(state, val) {
      //分类的滚动值1
      state.u_partcode = val;
    },
    titleStatus(state, val) {
      //分类的滚动值1titleStatus
      state.titleStatus = val;
    }
  },
  actions: {
    // commTotal({commit},addGoodsParameter){
    //   console.log(addGoodsParameter);
    //   return new Promise((resolve, reject) => {
    //     axios.post('http://test1.djzysm.com/api/cart/cart_save',qs.stringify({
    //       token:addGoodsParameter.token,
    //       id:addGoodsParameter.id,
    //       itemcode:addGoodsParameter.itemcode,
    //       box_quantity:addGoodsParameter.box_quantity,
    //       scattered_quantity:addGoodsParameter.scattered_quantity
    //     })).then(resp => {
    //       resolve(resp)
    //     }).catch(err => {
    //       reject(err)
    //     })
    //   })
    // },
  },
  plugins: [vuexLocal.plugin]
});



// WEBPACK FOOTER //
// ./src/store/index.js